<template>
  <div class="card p-shadow-app p-p-4">
    <div class="p-d-flex p-jc-between p-ai-center p-mb-3">
      <h2 class="p-m-0">Equipamentos</h2>
    </div>

    <div style="height: 65vh">
      <DataTable
        :value="equipments"
        :filters.sync="filters"
        :loading="loading"
        responsiveLayout="scroll"
        filterDisplay="row"
        class="p-datatable-sm"
        scrollable
        scrollHeight="flex"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 20, 50, 100]"
        :lazy="true"
        :totalRecords="totalRecords"
        @filter="fetchEquipments"
        @sort="fetchEquipments"
        @page="fetchEquipments"
      >
        <template #header>
          <div>
            <Button
              icon="pi pi-plus"
              @click="createEquipment()"
              v-if="can('manageEquipments')"
            />
          </div>
        </template>
        <template #empty> Nenhum equipamento encontrado. </template>
        <template #loading> A carregar... </template>
        <Column field="brand" header="Marca" filterField="brand" sortable>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column field="model" header="Modelo" filterField="model" sortable>
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column
          field="serie"
          header="Número de Série"
          filterField="serie"
          sortable
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>

        <Column field="situation" header="Situação" filterField="situation">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column field="clientName" header="Cliente" filterField="clientName">
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          field="clientMobilPhone"
          header="Cliente Telemovel"
          filterField="clientMobilPhone"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              v-model="filterModel.value"
              class="p-column-filter"
              @input="filterCallback()"
            />
          </template>
        </Column>
        <Column
          header="Ações"
          style="width: 100px"
          v-if="can('manageEquipments')"
        >
          <template #body="slotProps">
            <Button
              icon="pi pi-pencil"
              class="p-button-sm p-button-text"
              @click="updateEquipment(slotProps.data)"
            />
          </template>
        </Column>
      </DataTable>
    </div>
    <EquipmentModal
      :visible.sync="modalVisible"
      :data="formData"
      @cancel="closeForm"
      @created="createdEquipment"
      @updated="updatedEquipment"
    />
  </div>
</template>

<script>
import EquipmentService from "@/services/equipment.service";
import { FilterMatchMode } from "primevue/api";
import EquipmentModal from "@/components/equipaments/EquipmentModal.vue";

export default {
  name: "EquipmentList",
  components: { EquipmentModal },
  data() {
    return {
      loading: false,
      equipments: [],
      modalVisible: false,
      formData: {},
      totalRecords: 0,
      currentPage: 1,
      perPage: 50,
      filters: {
        id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        brand: { value: null, matchMode: FilterMatchMode.CONTAINS },
        model: { value: null, matchMode: FilterMatchMode.CONTAINS },
        serie: { value: null, matchMode: FilterMatchMode.CONTAINS },
        situation: { value: null, matchMode: FilterMatchMode.CONTAINS },
        clientMobilPhone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        clientEmail: { value: null, matchMode: FilterMatchMode.CONTAINS },
        clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  async activated() {
    await this.fetchEquipments();
  },
  async created() {
    await this.fetchEquipments();
  },
  methods: {
    buildQueryParams(page = 1) {
      const params = new URLSearchParams();

      params.append('page', page);

      if (this.search) {
        params.append('search', this.search);
        return params;
      }

      for (const [key, filter] of Object.entries(this.filters)) {
        if (filter.value !== null && filter.value !== '') {
          params.append(`filters[${key}]`, filter.value);
        }
      }

      return params;
    },
    async fetchEquipments(event = {}) {
      try {
          this.loading = true;

          const page = event.page ? event.page + 1 : 1;

          const params = this.buildQueryParams(page);
          params.append('per_page', event.rows || this.perPage);

          const response = await EquipmentService.getAll(params);

          this.equipments = response.data;
          this.totalRecords = response.meta.total;
          this.currentPage = response.meta.current_page;

      } catch (error) {
          this.$toast.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao carregar equipamentos',
              life: 3000
          });
      } finally {
          this.loading = false;
      }
    },
    emptyFormData() {
      return (this.formData = {
        id: null,
        status: "",
        serialNumber: "",
        brand: "",
        model: "",
        clientId: null,
        purchaseDate: null,
        observation: "",
      });
    },
    closeForm() {
      this.modalVisible = false;
      return this.emptyFormData();
    },
    createEquipment() {
      this.emptyFormData();
      return this.modalVisible = true;
    },
    createdEquipment(equipment) {
      this.equipments.push(equipment);
      return this.closeForm();
    },
    updateEquipment(equipment) {
      this.formData = { ...equipment };
      this.formData.status = equipment.situation;
      this.formData.serialNumber = equipment.serie;
      this.formData.observation = equipment.comments;
      return (this.modalVisible = true);
    },
    updatedEquipment(equipment) {
      const index = this.equipments.findIndex(
        (item) => item.id === equipment.id
      );
      if (index !== -1) {
        this.equipments.splice(index, 1, equipment);
      }
      return this.closeForm();
    },
  },
};
</script>
